var _defs, _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgFlagPtPt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pt"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    rx: 2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pt)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    fill: "#DA020E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.6,
    height: 18,
    fill: "#046A38"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.6,
    cy: 9,
    r: 4,
    fill: "none",
    stroke: "#FFE900",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.1,
    y: 7.1,
    width: 3,
    height: 3.8,
    rx: 0.6,
    fill: "#FFFFFF",
    stroke: "#DA020E",
    strokeWidth: 0.7
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 17,
    rx: 1.5,
    fill: "none",
    stroke: "#212121",
    strokeOpacity: 0.12
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagPtPt);
export default __webpack_public_path__ + "static/media/flag-pt-PT.6236ea4d8de10d16e447b46429b2162f.svg";
export { ForwardRef as ReactComponent };